import React, { CSSProperties, FC, memo } from "react"
import { GetCompanyQuery, NewBookingInput, OptionalInputFieldsInput } from "../../../../../generated/graphql"
import FormItem from "antd/lib/form/FormItem"
import { Button, Checkbox } from "antd"
import css from "../../StepSummary2.module.css"
import type { NewBookingInputKeys } from "../bookingInputTypes"
import { blue } from "@ant-design/colors"
import classnames from "classnames"
import { LinkOutlined } from "@ant-design/icons"
import { URL_AGB } from "../../../../../models/url"
import { isEmbeddedForInternalRoutes } from "../../../../../helpers/embedMode"
// import { Link } from "@reach/router"

type AGBInputProps = {
    field: OptionalInputFieldsInput
    bookingData?: NewBookingInput
    updateBookingData: (key: NewBookingInputKeys, value: any) => void
    style?: CSSProperties
    showAlert?: boolean
    companySettings?: GetCompanyQuery["companyPublic"]
}

const AGBInput: FC<AGBInputProps> = ({ field, bookingData, updateBookingData, style, showAlert, companySettings }) => {
    const updateAGBConfirmation = (checked: boolean) => {
        updateBookingData("agbConfirmed", checked)
    }

    const AGBLink = ({ label, icon }: { label?: string; icon?: boolean }) => {
        // Prüfe ob externe URL vorhanden ist
        const externalUrl = companySettings?.agb
        // Prüfe ob App in iFrame läuft (für interne Route)
        const isInIframe = isEmbeddedForInternalRoutes()

        // Wenn keine externe URL vorhanden ist und App in iFrame läuft, verwende interne Route
        if (!externalUrl && isInIframe) {
            return (
                <Button style={{ paddingLeft: 0, fontWeight: 500 }} type='link' size='small'>
                    <a href={`#${URL_AGB}`}>
                        {label ?? label}
                        {icon && <LinkOutlined style={{ color: blue[5], marginLeft: 3, fontSize: "small" }} />}
                    </a>
                </Button>
            )
        }

        // Externe URL hat Priorität
        if (externalUrl) {
            return (
                <Button style={{ paddingLeft: 0, fontWeight: 500 }} type='link' size='small'>
                    <a href={externalUrl} target='_blank' rel='noopener noreferrer'>
                        {label ?? label}
                        {icon && <LinkOutlined style={{ color: blue[5], marginLeft: 3, fontSize: "small" }} />}
                    </a>
                </Button>
            )
        }

        return null
    }

    const alertAndNotChecked = showAlert && !Boolean(bookingData?.agbConfirmed)

    return (
        <>
            <FormItem style={style} key={field.name}>
                <Checkbox
                    data-testid='agb-checkbox'
                    className={alertAndNotChecked ? classnames(css.inputLabel, css.alert) : css.inputLabel}
                    onChange={(e) => updateAGBConfirmation(e.target.checked)}
                    checked={Boolean(bookingData?.agbConfirmed)}
                >
                    <AGBLink label={field.label ?? undefined} />
                </Checkbox>
                <div className={css.inputDescription}>
                    {field.description}
                    <AGBLink icon />
                </div>
            </FormItem>
        </>
    )
}

export default memo(AGBInput)
